<template>

    <b-col class="customcard col-8 mx-auto">
        <div v-if="$root.default_academic_year[0] == '0'" style="min-height:120px"> Please select correct academic year
            to view data.</div>
        <div v-else style=" text-align: -webkit-center; padding: 6px;">
            <b-row align-h="center">
            <h5>Warnings and Errors Preview</h5>
            </b-row>

            <b-row v-if="instiConfigErrorsLoading" class="text-center" align-h="center" align-v="center">
            <b-spinner :variant="randomColor()"></b-spinner>
            </b-row>
            <b-row v-else>
            <b-col class="p-0">
                <div v-b-modal.instiConfigErrorsModel v-b-tooltip.hover
                :title="'You have ' + instiConfigErrors.length + ' errors'" class="circle circle-error">
                {{
                    instiConfigErrors.length > 0 ? instiConfigErrors.length : "✓"
                }}
                </div>
            </b-col>
            <b-col class="p-0">
                <div v-b-modal.instiConfigErrorsModel v-b-tooltip.hover
                :title="'You have ' + instiConfigWarnings.length + ' warnings'" class="circle circle-warning">
                {{
                    instiConfigWarnings.length > 0
                        ? instiConfigWarnings.length
                        : "✓"
                }}
                </div>
            </b-col>
            <!-- <b-col class="p-0">
                <div v-b-tooltip.hover :title="'Tou have ' + 0 + ' messages'"
                :class="0 <1 ? 'circle circle-gray' :'circle circle-info'">
                0
                </div>
            </b-col> -->
            <b-col class="p-0">
                <div v-b-tooltip.hover :title="
                instiConfigErrors.length < 1
                    ? 'Everything done'
                    : 'Please clear errors & warnings'
                " :class="
    instiConfigErrors.length < 1
    ? 'circle circle-success'
    : 'circle circle-gray'
    ">
                ✓
                </div>
            </b-col>
            </b-row>
        </div>
        <b-modal id="instiConfigErrorsModel" hide-footer hide-header size="lg">
            <table class="table  table-striped table-bordered">
            <tr>
                <th>
                SI. No.
                </th>
                <th>
                Description
                </th>
            </tr>
            <tr v-if="instiConfigErrors.length">
                <td colspan="2" style="background-color: #e54646;">Errors</td>
            </tr>
            <tr v-for="(instiConfigError, errorindex) in instiConfigErrors" :key="'error' + errorindex">
                <td>{{ errorindex + 1 }}</td>
                <td>
                {{ instiConfigError }}
                </td>
            </tr>

            <tr v-if="instiConfigWarnings.length">
                <td colspan="2" style="background-color:  #e3c622;">Warnings</td>
            </tr>
            <tr v-for="(instiConfigWarning, warningindex) in instiConfigWarnings" :key="'waring' + warningindex">
                <td>{{ warningindex + 1 }}</td>
                <td>
                {{ instiConfigWarning }}
                </td>
            </tr>
            </table>
        </b-modal>
        </b-col>

</template>

<script>
export default {
  async created() {
    this.getDashboardCardsConfigAlerts();
  },
  data() {
    return {
      instiConfigErrorsLoading: true,
      instiConfigErrors: [],
      instiConfigWarnings: [],
    };
  },
  methods: {
    async getDashboardCardsConfigAlerts() {
      this.instiConfigErrorsLoading = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/institution/institutionuser/configuration/alerts`;
      await this.$axios
        .get(url)
        .then((response) => {
          this.instiConfigErrors = response.data.errors;
          this.instiConfigWarnings = response.data.warnings;
          this.instiConfigErrorsLoading = false;
        })
        .catch(() => {
          this.instiConfigErrorsLoading = false;
        });
    },

    randomColor() {
      return [
        "primary",
        "secondary",
        "danger",
        "warning",
        "success",
        "info",
        "light",
        "dark",
      ].sort(() => 0.5 - Math.random())[0];
    },
  },
};
</script>

<style>
.circle {
  margin: 3px;
  width: 70px;
  line-height: 50px;
  border-radius: 50%;
  text-align: center;
  font-size: 30px !important;
  font-weight: 900;
}

.circle-error {
  border: 10px solid rgb(187, 11, 11);
}

.circle-warning {
  border: 10px solid rgb(213, 183, 12);
}

.circle-info {
  border: 10px solid rgb(27, 91, 173);
}

.circle-success {
  border: 10px solid rgb(11, 162, 57);
}

.circle-gray {
  border: 10px solid rgb(202, 208, 204);
  color: rgb(200, 207, 202);
}
</style>
